<div class="header-title">
    <div class="left" *ngIf="!loading">
        <div class="back-icon">
            <img src="assets/navbar-component-images/fluent_ios-arrow-24-filled.svg" alt="" (click)="goBack()">
        </div>
        <div class="title">
            <h2 *ngIf="topic || news.Topic_OD">{{preload ? topic : news.Topic_OD}}</h2>
        </div>
    </div>
    <div class="right" *ngIf="!loading">
        <div class="date-views" *ngIf="showViews">
            <i [ngClass]="{
            'pi-thumbs-up-fill text-success': news.SentimentLabel === 'pos',
            'pi-minus-circle text-warning': news.SentimentLabel === 'neu',
            'pi-thumbs-down-fill text-danger': news.SentimentLabel === 'neg'
            }" class="pi"></i>
            <p>
                {{ (+news.PublishDate_OD) * 1000 | date:'dd MMMM yyyy HH:mm' }}
            </p>
            <div class="line-split"></div> <img src="assets/navbar-component-images/Show.svg" alt="">
            <p>
                {{news.Views}}
            </p>
        </div>
    </div>
</div>
<div class="news-container">
    <div class="content">
        <div class="progress-spinner-container" *ngIf="loading">
            <p-progressSpinner strokeWidth="4"></p-progressSpinner>
        </div>


        <div *ngIf="writer && !loading" [style]="{'display': 'flex', 'align-items': 'center', 'gap': '0.5rem'}">
            <p-avatar image="assets/navbar-component-images/Avatar.png" size="large" shape="circle"></p-avatar>
            <span class="font-bold">
                <h3 style="color: black;">{{ writer }}</h3>
            </span>
        </div>


        <div class="image-field" *ngIf="!loading">
            <p-galleria [value]="images" [numVisible]="5" [showThumbnails]="false" [showIndicators]="images.length > 1"
                [showItemNavigatorsOnHover]="true" [showItemNavigators]="images.length > 1">
                <ng-template pTemplate="item" let-item>
                    <img [src]="item" (error)="onImageError($event)" style="width: 100%; border-radius: 16px;">
                </ng-template>
            </p-galleria>
        </div>



        <div>
            <h4 *ngIf="topic || news.Topic_OD">{{preload ? topic : news.Topic_OD}}</h4>
        </div>

        <div *ngIf="!loading && (source ? source : news.Link_OD)">
            <span>แหล่งที่มา: </span>
            <span><a *ngIf="(source ? source : news.Link_OD).match('https://www.')"
                    [href]="source ? source : news.Link_OD">{{ source ? source : news.Link_OD }}</a></span>
            <span *ngIf="!(source ? source : news.Link_OD).match('https://www.')">{{ source ? source : news.Link_OD
                }}</span>
        </div>

        <div class="wordsegment-container" *ngIf="isFromSearch">
            <app-wordsegment [searchQuery]="searchQuery"
                (segmentedWordsChange)="onSegmentedWordsChange($event)"></app-wordsegment>
        </div>

        <div class="BreakLine"></div>

        <div class="information" *ngIf="!loading && showDetail"
            [innerHTML]="(preload ? detail : news.Detail_OD) | highlighter: (news.LOCATION ? news.LOCATION : [])"></div>
        <app-comments *ngIf="!loading && showComment" [comments]="comments"></app-comments>
    </div>
    <div class="additional" *ngIf="showMap && showRelated">
        <div class="location" *ngIf="showMap">
            <div class="location-title">
                <img src="assets/search-component-images/mapPin.svg" alt="">
                <h3>จุดเกิดเหตุข่าว</h3>
            </div>
            <div class="map" [ngClass]="{'disable':disableState}">
                <div *ngIf="latitude && longitude" class="la-long">{{latitude.toFixed(6)}} , {{longitude.toFixed(6)}}
                </div>
                <div #mapPanel style="width: 95%; height: 240px;"></div>
            </div>
        </div>
        <div class="related" *ngIf="relative && showRelated">
            <div class="related-title">
                <div style="display: flex; position: relative; width: fit-content; height: fit-content;">
                    <img src="assets/navbar-component-images/banner.svg" alt="banner.svg" [style]="{'scale': '0.8'}">
                    <img src="assets/navbar-component-images/bannerVector.svg" alt="bannerVector.svg"
                        style="position: absolute; left: 34%; top: 20%; scale: 0.8;">
                </div>
                <h3>ข่าวที่เกี่ยวข้อง ({{relative.length}})</h3>
            </div>
            <div *ngIf="!loading" style="display: flex; flex-direction: column; gap: 20px;">
                <div class="related-news" *ngFor="let i of relative">
                    <a (click)="clickRelativeNews(i.Link_OD)">
                        <img [src]="getImageUrl(i.Picture_URL_OD)" [alt]="i.Picture_Alt_OD"
                            (error)="onImageError($event)">
                    </a>
                    <div class="details">
                        <img [src]="i.icon" alt="">
                        <a (click)="clickRelativeNews(i.Link_OD)">{{i.Topic_OD}}</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>